import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import { toast } from "react-toastify";
import App from "containers/App";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./store";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import browserHistory from "utils/history";

// ===== EXTENSION =====
// Kiểm tra config từ localStorage
const getFormatConfig = () => {
  try {
    const config = localStorage.getItem("numberFormatConfig");
    return config ? JSON.parse(config) : null;
  } catch {
    return null;
  }
};

const config = getFormatConfig();

// Chỉ định nghĩa hàm doidau nếu đang dùng format Việt Nam
if (config && config.decimalSeparator === ",") {
  String.prototype.doidau = function () {
    return this.replace(/\./g, "#") // . → #
      .replace(/,/g, ".") // , → .
      .replace(/#/g, ","); // # → ,
  };
} else {
  // Không đổi gì cả
  String.prototype.doidau = function () {
    return this.toString();
  };
}

const store = configureStore();
toast.configure();

ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory}>
      <Suspense fallback={"Loading..."}>
        <App />
      </Suspense>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// initialize firebase for push notification.
// initializeFirebase();
// const messaging = firebase.messaging();
// messaging.usePublicVapidKey("BEsBewuGG1j0DvOr65lpGnMXHGWwqwvrLCn5VAIZ0M6v9EAGX0EfNgQ7AGDrpXfFZIt8IhPUJteObE3Gnb9XL9s");

// if(!localStorage.getItem("notification-token")){
// 	askForPermissionToReceiveNotifications();
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('../firebase-messaging-sw.js')
//   .then(function(registration) {
//     console.log('Registration successful, scope is:', registration.scope);
//   }).catch(function(err) {
//     console.log('Service worker registration failed, error:', err);
//   });
// }
